import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function TofuWrap() {
  return (
    <>
      <HeaderWithSearch />
      <main
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
          padding: 0,
          margin: 0,
        }}
      >
        <section
          className="recipe-hero-anim"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "60px 20px 40px 20px",
          }}
        >
          <h1
            className="recipe-title-anim"
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: 16,
              textAlign: "center",
            }}
          >
            Tofu Wrap
          </h1>
          <span className="season-badge season-spring" style={{ marginBottom: 24 }}>🌸 Best in Spring</span>
          <ImageWithFallback
            src="/tofu_wrap.jpg"
            alt="Tofu Wrap"
            className="recipe-image-anim"
            style={{
              width: 400,
              height: 300,
              objectFit: "cover",
              borderRadius: 24,
              boxShadow: "0 4px 32px rgba(0,0,0,0.10)",
              marginBottom: 32,
            }}
          />
          <div
            style={{
              maxWidth: 800,
              fontSize: "1.1rem",
              color: "#333",
              lineHeight: 1.8,
            }}
          >
            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Ingredients:
            </h2>
            <ul className="ingredient-list" style={{ marginBottom: 24, paddingLeft: 20 }}>
              <li>1 block firm tofu (14 oz)</li>
              <li>2 medium sized flour tortillas</li>
              <li>2 tbsp olive oil</li>
              <li>1 tbsp soy sauce</li>
              <li>1 tsp chopped garlic</li>
              <li>1 red bell pepper, sliced</li>
              <li>1/4 cup fresh cilantro</li>
              <li>2 green onions, chopped</li>
              <li>2 tbsp tahini or peanut butter</li>
              <li>1 tbsp chipotle sauce, taco sauce, chili sauce, and salsa</li>
            </ul>

            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Instructions:
            </h2>
            <ol className="instructions-list" style={{ paddingLeft: 20 }}>
              <li style={{ marginBottom: 12 }}>
                <strong>Prepare the tofu:</strong> Drain and press tofu to remove excess water. Cut into strips.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Marinate:</strong> Mix soy sauce, garlic, in a bowl. Add tofu strips and marinate for 15 minutes.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Cook tofu:</strong> Heat olive oil in a pan over medium-high heat. Add the ingredients in the bowl and cook marinated tofu strips until golden brown and crispy, about 3-4 minutes per side.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Make sauce:</strong> Whisk together tahini, chipotle sauce, until smooth.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Prepare vegetables:</strong> Slice bell peppers, chop cilantro and green onions.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Assemble wraps:</strong> Warm tortillas slightly. Spread sauce in the center, add crispy tofu, and top with vegetables, cilantro, and green onions.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Wrap and serve:</strong> Fold the bottom edge up, fold in the sides, and roll tightly. Cut in half diagonally and serve immediately.
              </li>
            </ol>

            <div
              className="chef-tips-box"
              style={{
                background: "#f8f9fa",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips:
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Press tofu well for better texture and flavor absorption</li>
                <li>Make extra sauce - it's great for dipping!</li>
                <li>Add sriracha or chili flakes for a spicy kick</li>
                <li>Best served fresh, but can be wrapped in foil for later</li>
              </ul>
            </div>

            <div
              className="health-benefits-box"
              style={{
                background: "#eef9f0",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Tofu is a great plant-based source of protein, iron, and calcium.</li>
                <li>Bell peppers add a big dose of vitamin C along with fiber and crunch.</li>
                <li>A lighter, plant-forward alternative to meat-filled wraps that's just as filling.</li>
                <li>Using a whole wheat tortilla boosts the fiber content even further.</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default TofuWrap;